module.exports = __webpack_public_path__ + "img/vega.5c7453de.svg";